<template>
    <v-container :fluid="$vuetify.breakpoint.md" class="mb-12 mb-lg-0">
        <v-row justify="center">
            <v-col cols="12" lg="11">
                <v-card width="100%">
                    <v-card-title class="d-block text-center font-weight-bold primary white--text py-2" style="word-break: normal">FORMULARIO DE SOPORTE</v-card-title>
                    <v-card-subtitle class="text-center mt-4">Estimado cliente, por favor describa muy bien su consulta, en sólo 2 pasos usted nos podrá enviar los detalles.</v-card-subtitle>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" lg="11">
                <v-stepper v-model="e1">
                    <v-stepper-header>
                        <v-stepper-step :complete="e1 > 1" step="1">50%</v-stepper-step>
                        <v-divider/>
                        <v-stepper-step step="2">100%</v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-form ref="form" @submit.prevent="submit" lazy-validation v-model="valid">
                            <v-stepper-content class="px-2 px-md-4" step="1">
                                <v-card class="mb-12" outlined color="transparent">
                                    <v-row justify="center">
                                        <v-col cols="12" md="5">
                                            <v-select
                                                :label="labels.type"
                                                :items="types"
                                                name="type"
                                                v-model="form.type"
                                                :error-messages="errors.type"
                                                :disabled="loading"
                                                :rules="[rules.required('type')]"
                                                @select="clearErrors('type')"
                                                prepend-inner-icon="mdi-pound"
                                                item-text="value"
                                                filled>
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" md="5" v-if="form.type === 'Soporte'">
                                            <v-select
                                                :label="labels.service"
                                                :items="services"
                                                name="service"
                                                v-model="form.service"
                                                :error-messages="errors.service"
                                                :disabled="loading"
                                                :rules="[rules.required('service')]"
                                                @select="clearErrors('service')"
                                                prepend-inner-icon="mdi-pound"
                                                item-text="value"
                                                filled>
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" :md="(form.type === 'Soporte' ? 10 : 5)">
                                            <v-text-field
                                                :label="labels.subject"
                                                v-model="form.subject"
                                                type="text"
                                                name="subject"
                                                :error-messages="errors.subject"
                                                :rules="[rules.required('subject'), rules.min('subject', 5, 'El')]"
                                                :disabled="loading"
                                                prepend-inner-icon="mdi-text"
                                                @input="clearErrors('subject')"
                                                filled/>
                                        </v-col>
                                        <v-col cols="12" md="10">
                                            <v-textarea
                                                :label="labels.description"
                                                v-model="form.description"
                                                name="description"
                                                counter="255"
                                                :error-messages="errors.description"
                                                :disabled="loading"
                                                :rules="[rules.req('description'), rules.min('description', 12, 'La'), rules.max('description', 255, 'La')]"
                                                prepend-inner-icon="mdi-clipboard-text"
                                                @input="clearErrors('description')"
                                                no-resize
                                                rows="4"
                                                filled/>
                                        </v-col>
                                    </v-row>
                                </v-card>

                                <v-btn color="error" @click="$router.go(-1)">Salir</v-btn>
                                <v-btn class="float-right" color="primary" @click="next(1)">Continuar</v-btn>
                            </v-stepper-content>

                            <v-stepper-content class="px-2 px-md-4" step="2">
                                <v-card class="mb-12" outlined color="transparent">
                                    <v-row justify="center">
                                        <v-col cols="12" md="5">
                                            <h3 class="text-center">{{labels.type}}</h3>
                                            <p class="text-center">{{form.type}}</p>
                                        </v-col>
                                        <v-col cols="12" md="5" v-if="form.type === 'Soporte'">
                                            <h3 class="text-center">{{labels.service}}</h3>
                                            <p class="text-center">{{form.service}}</p>
                                        </v-col>
                                        <v-col cols="12" :md="(form.type === 'Soporte' ? 10 : 5)">
                                            <h3 class="text-center">{{labels.subject}}</h3>
                                            <p class="text-center">{{form.subject}}</p>
                                        </v-col>
                                        <v-col cols="12" md="10">
                                            <h3 class="text-center">{{labels.description}}</h3>
                                            <p class="text-center">{{form.description}}</p>
                                        </v-col>
                                    </v-row>
                                </v-card>

                                <v-btn color="tertiary" dark @click="e1 = e1 - 1">Atras</v-btn>
                                <v-btn class="float-right" color="success" @click="submit">Enviar</v-btn>
                            </v-stepper-content>
                        </v-form>
                    </v-stepper-items>
                </v-stepper>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios';
    import Form from "../helpers/form";

    export default {
        name: "Ticket",
        mixins: [ Form ],
        props: [ 'user' ],
        data: () => ({
            e1:  1,
            types: [
                { value: 'Servicio al Cliente' },
                { value: 'Soporte' },
                { value: 'Facturación' }
            ],
            services: [],
            labels: {
                type: 'Departamento',
                service: 'ID Servicio',
                subject: 'Asunto',
                description: 'Descripción'
            },
            form: {
                type: null,
                service: null,
                subject: null,
                description: null
            }
        }),
        mounted() {
            this.getService();
        },
        methods: {
            next(code) {
                if (this.$refs.form.validate()) {
                    this.e1 = code + 1;
                }
            },
            getService() {
                axios.get('/api/services').then((res) => {
                    this.services = res.data.items;
                }).catch(err => {
                    this.handleErrors(err.response.data.errors);
                }).then(() => {
                    this.loading = false;
                });
            },
            submit() {
                if (this.$refs.form.validate()) {
                    this.loading = true;
                    axios.post('/api/tickets', this.form)
                        .then((res) => {
                            this.$toast.success(res.data.status, { icon: 'mdi-check-circle' });
                            this.$router.push({ name: 'TicketView', params: { id: res.data.id } });
                        }).catch(err => {
                            this.handleErrors(err.response.data.errors);
                        }).then(() => {
                            this.loading = false;
                        })
                }
            }
        }
    }
</script>

<style scoped>

</style>
